import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CustomCreateButton } from '../../custom-create-button/custom-create-button.component';
import { IDropdownSelect, IHeader } from '../../../../../shared/interfaces/custom-work/customTable';
import { CustomTitle } from '../../../other/custom-title/custom-title.component';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'table-caption',
  standalone: true,
  imports: [CustomTitle, CommonModule, CustomCreateButton, TooltipModule, TranslateModule, DropdownModule, FormsModule, ButtonModule],
  templateUrl: './table-caption.component.html',
  styleUrl: './table-caption.component.scss'
})
export class TableCaptionComponent implements OnInit {
  @Input() header !: IHeader;

  #dropdownSelect?: IDropdownSelect;
  selected !: any;
  trans: any = {};

  constructor(private _ms: MessageService, private _t: TranslateService) { }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      SeleccioneUnRegistro: this._t.get('msg.SeleccioneUnRegistro'),
      errorSummary: this._t.get('form.msg.error-summary'),
    }));
  }

  onCreate() {
    if (!this.header?.onCreate) {
      throw new Error('Create method not implemented.');
    }
    this.header.onCreate();
  }

  get disabled() {
    return this.header?.disabled ?? false;
  }

  get tooltip() {
    return this.header?.tooltip;
  }

  get dropdownSelect() {
    return this.#dropdownSelect;
  }

  get customBtn1(){
    return this.header?.customBtn1;
  }

  get class() {
    return this.header?.class;
  }

  setDropdownSelect(data: IDropdownSelect) {
    this.#dropdownSelect = data;
  }

  onBtnClick(event: Event) {
    if (!this.selected) {
      this._ms.add({ severity: 'warn', summary: this.trans.errorSummary, detail: this.trans.SeleccioneUnRegistro });
      return;
    }
    this.#dropdownSelect?.onBtnClick(event, this.selected);
    this.selected = undefined;
  }
}
